import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { filter, uniq, pipe, compose, keys, groupBy, prop, map, propEq } from "ramda";
import { Flex } from "@base-ui";
import GenderButton from "./GenderButton";
import TargetButton from "./TargetButton";
import { allGenderTypes } from "utils/genders";
import { sort } from "utils/sort";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
export default function GraphFocusLabels(props) {
  var _measure$targetMeasur;
  var focusId = props.focusId,
    setFocusId = props.setFocusId,
    measure = props.measure,
    measurementsWithMetadata = props.measurementsWithMetadata,
    graphSelected = props.graphSelected;
  var genderKeys = Object.keys(allGenderTypes);
  var measureIds = measurementsWithMetadata && compose(keys, groupBy(prop("measureId")))(measurementsWithMetadata);
  var sortedGenderMeasures = measureIds ? pipe(map(function (id) {
    var _measure$submeasures;
    return measure === null || measure === void 0 ? void 0 : (_measure$submeasures = measure.submeasures) === null || _measure$submeasures === void 0 ? void 0 : _measure$submeasures.find(propEq("measureId", id));
  }), filter(function (x) {
    return x === null || x === void 0 ? void 0 : x.gender;
  }), uniq, function (x) {
    return x && sort(function (y) {
      return genderKeys.indexOf(y === null || y === void 0 ? void 0 : y.gender);
    }, x);
  })(measureIds) : [];
  var genderButtons = sortedGenderMeasures.map(function (submeasure) {
    return (submeasure === null || submeasure === void 0 ? void 0 : submeasure.gender) && /*#__PURE__*/_jsx(GenderButton, {
      "aria-label": "Makera punkter med k\xF6n: ".concat(allGenderTypes[submeasure.gender]),
      gender: submeasure.gender,
      disabled: measureIds.length !== 2 || graphSelected === "barchart",
      active: focusId === submeasure.gender,
      onClick: function onClick() {
        return setFocusId(function (old) {
          return old === submeasure.gender ? null : submeasure.gender;
        });
      },
      multipleGenders: measureIds.length === 2,
      children: allGenderTypes[submeasure.gender]
    }, submeasure.gender);
  });
  var targetButtons = measure === null || measure === void 0 ? void 0 : (_measure$targetMeasur = measure.targetMeasurements) === null || _measure$targetMeasur === void 0 ? void 0 : _measure$targetMeasur.map(function (target, idx) {
    var style = {
      marginLeft: idx === 0 ? "10px" : "",
      width: "".concat(400 / measure.targetMeasurements.length, "px"),
      minWidth: "180px"
    };
    return /*#__PURE__*/_jsx("div", {
      title: target.TargetName,
      children: /*#__PURE__*/_jsx(TargetButton, {
        className: "graph-focus-labels",
        "aria-label": "Makera m\xE5lv\xE4rde: ".concat(target.Value, " fr\xE5n ").concat(target.TargetName),
        idx: idx,
        style: style,
        active: focusId === target.Id,
        onClick: function onClick() {
          return setFocusId(function (old) {
            return old === target.Id ? null : target.Id;
          });
        },
        children: target.TargetName
      })
    }, target.Id);
  });
  return /*#__PURE__*/_jsxs(Flex.Row, _objectSpread(_objectSpread({
    justifyContent: "flex-end",
    flexWrap: "wrap",
    mb: "20px"
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(Flex.Row, {
      width: "fit-content",
      children: genderButtons
    }), targetButtons]
  }));
}